export const config = {
  clientKey: 'oblak',
  languageKey: 'en',
  // Client canceled the configurator subscription. Set back to `true` to
  // restore the full configurator flow - no other change is needed.
  configuratorEnabled: false,
}
